import React from 'react'

const SpiceJet = () => {
  return (
    <div>SpiceJet</div>
  )
}

export default SpiceJet